// Help Button Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Show the help button once page is ready
  const helpBtn = document.querySelector(".help_btn_custom");
  if (helpBtn) {
    // Small delay to ensure CSS is applied
    setTimeout(function() {
      helpBtn.classList.add('help-btn-ready');
    }, 100);
  }
  
  // Chat bot hide and show
  const popupChatBot = document.querySelector(".popup-chat-bot");
  const closeBtn = document.querySelector(".popup-chat-bot .popup-contact-confirmation__close");
  
  if (helpBtn) {
    helpBtn.addEventListener('click', function() {
      if (popupChatBot) {
        popupChatBot.classList.add("show");
      }
    });
  }
  
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      if (popupChatBot) {
        popupChatBot.classList.remove("show");
      }
    });
  }
});
